import React from 'react';
import { Link } from 'react-router-dom';
import './Popularmenu.css';

function PopularMenu() {
  return (
    <div className="popularmenu-page-wrapper">
      {/* Popular Menu Hero Banner Section */}
      <div className="popularmenu-hero">
        <div className="popularmenu-hero-overlay"></div>
        <div className="popularmenu-hero-content">
          <h2>Popular Menu</h2>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="popularmenu-content-section">
        <div className="popularmenu-breadcrumb-container">
          <Link to="/" onClick={() => window.scrollTo(0,0)} className="breadcrumb-home" style={{ textDecoration: 'none' }}>Home</Link>
          <span className="breadcrumb-separator"> / </span>
          <span className="breadcrumb-current">Popular Menu</span>
        </div>

        <div className="popularmenu-title-container">
          <h1 className="popularmenu-headline">
            <span className="green-accent">Popular</span> <span className="black-accent">Menu</span>
          </h1>
        </div>

        <div className="popularmenu-cards-grid">
          <div className="popularmenu-card">
            <img src="/Image/popular_biriyani.png" alt="Biriyani" className="popularmenu-card-img" />
            <div className="popularmenu-card-overlay">
              <h3 className="popularmenu-card-title">Biriyani</h3>
            </div>
          </div>

          <div className="popularmenu-card">
            <img src="/Image/Menu2.jpg" alt="Sea Foods" className="popularmenu-card-img" />
            <div className="popularmenu-card-overlay">
              <h3 className="popularmenu-card-title">Sea Foods</h3>
            </div>
          </div>

          <div className="popularmenu-card">
            <img src="/Image/Menu3.jpg" alt="Bakes" className="popularmenu-card-img" />
            <div className="popularmenu-card-overlay">
              <h3 className="popularmenu-card-title">Bakes</h3>
            </div>
          </div>

          <div className="popularmenu-card">
            <img src="/Image/Menu4.jpg" alt="Burger" className="popularmenu-card-img" />
            <div className="popularmenu-card-overlay">
              <h3 className="popularmenu-card-title">Burger</h3>
            </div>
          </div>
        </div>

        <p className="popularmenu-footer-text">
          Get the ZustGo app to discover trending dishes near you. Order in seconds and enjoy fast delivery at your doorstep.
        </p>
      </div>
    </div>
    
  );
}

export default PopularMenu;